module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.CLIENT_PORTAL_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3007' : envUrl;

          if (true && isDev) {
            console.error('[Module Federation] CLIENT_PORTAL_URL not configured for production');
            reject(new Error('Client Portal MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.clientPortal);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load clientPortal remote from:', remoteUrl);
            reject(new Error('Failed to load Client Portal MFE'));
          };
          document.head.appendChild(script);
        });